.container {
  top: var(--tab-bar-height);
  background: var(--color-surfaces-app-background-0);
  position: absolute;
  display: flex;
  flex-direction: column;
  width: var(--drawer-width-closed);
  height: calc(100% - var(--tab-bar-height));
  transition: all 200ms ease-in;
  z-index: 9999;

  transform: translateX(calc(-1 * var(--drawer-width-closed)));

  &[data-is-open='true'] {
    transform: translateX(0);
  }

  @media screen and (min-width: $bp-medium) {
    top: 0;
    height: 100%;
    transform: translateX(0);
    background: black;
    position: relative;
  }
}
